import React from "react";
import { FaUserFriends } from "react-icons/fa";

function AdherentPrepaEmptyState() {
  return (
    <div className="rounded-[2rem] border border-dashed border-slate-300 bg-white p-8 text-center shadow-xl shadow-slate-200/50 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-[1.5rem] bg-slate-100 text-slate-500 dark:bg-white/10 dark:text-white/60">
        <FaUserFriends className="text-2xl" />
      </div>

      <h2 className="mt-5 font-titre text-2xl font-bold text-slate-950 dark:text-white">
        Aucun judoka disponible
      </h2>

      <p className="mx-auto mt-3 max-w-xl text-sm font-medium leading-7 text-slate-500 dark:text-white/50">
        Aucun adhérent n'est rattaché au compte connecté. Ajoute ou rattache un
        adhérent pour afficher les exercices de préparation physique.
      </p>
    </div>
  );
}

export default AdherentPrepaEmptyState;